import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useCallback } from "react";

import { useAuthData } from "../auth/auth-data-context";
import { useAuthToken } from "../auth/auth-token-context";
import * as css from "./impersonation-banner.module.css";

export const ImpersonationBanner = memo(function ImpersonationBanner() {
  const { actor, isImpersonating, exitImpersonation } = useAuthToken();
  const { referrer } = useAuthData();

  const handleExit = useCallback(() => {
    exitImpersonation();
    window.close();
  }, [exitImpersonation]);

  if (!isImpersonating || !actor) {
    return null;
  }

  return (
    <Flex
      align="center"
      bgColor="warning-secondary"
      className={css.banner}
      data-testid="impersonation-banner"
      gap="xl"
      justify="space-between"
      px="3xl"
      py="md"
      role="alert"
    >
      <Flex dir="column" gap="xxs">
        <Text as="span" fontSize="sm" fontWeight="semibold" m="none">
          Viewing as {referrer?.name ?? "referrer"}
        </Text>
        <Text as="span" fontSize="xs" fontWeight="regular" m="none">
          Admin impersonation · {actor.adminEmail}
        </Text>
      </Flex>
      <RedoButton
        hierarchy="secondary"
        onClick={handleExit}
        size="sm"
        text="Exit impersonation"
      />
    </Flex>
  );
});
